import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    downtimeWrapper: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 8,
        padding: 10,
        cursor: "pointer",
        width: 140,
    },
    downtimeWrapperSelected: {
        background: theme.palette.secondary.main,
    },
    offline: {
        background: theme.palette.warning.main,
    },
    name: {
        fontSize: 14,
        fontWeight: 400,
        fontFamily: "Source Sans 3",
        color: theme.palette.text.primary,
        maxWidth: 65,
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden",
    },
    downtime: {
        fontSize: 14,
        fontWeight: 400,
        fontFamily: "Source Sans 3",
        display: "flex",
        alignItems: "center",
        gap: 8,
    },
    downtimeUp: {
        color: theme.palette.success.main,
        display: "flex",
        alignItems: "center",
        "& svg": {
            width: 20,
            height: 20,
        },
    },
    downtimeDown: {
        color: theme.palette.error.main,
        display: "flex",
        alignItems: "center",
        "& svg": {
            width: 20,
            height: 20,
            transform: "rotate(180deg) !important",
        },
    },
    label: {
        fontSize: 12,
        fontWeight: 700,
        color: theme.palette.primary.dark,
        textTransform: "uppercase",
        marginBottom: 6,
    },
    value: {
        fontFamily: "Source Sans 3",
        fontWeight: 400,
        fontSize: 14,
    },
    shiftEnded: {
        color: theme.palette.error.main,
        fontWeight: 600,
        fontSize: 14,
    },
    dataWrapper: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    valueWithError: {
        fontFamily: "Source Sans 3",
        color: theme.palette.error.main,
        fontWeight: 700,
        fontSize: 14,
    },
    offlineIconWrapper: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
    },
    offlineIconLabel: {
        fontSize: 12,
        fontWeight: 700,
        fontFamily: "Source Sans 3",
        color: theme.palette.primary.main,
    },
    tooltip: {
        "&.MuiTooltip-popper .MuiTooltip-tooltip": {
            backgroundColor: theme.palette.secondary.main,
        },
    },
    tooltipTexts: {
        "&.MuiTypography-root": {
            fontSize: "14px",
            textAlign: "left",
            color: theme.palette.text.primary,
            fontWeight: 600,
            fontFamily: "Source Sans 3",
            paddingBottom: "5px",
        },
    },
    noDataWrapper: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: 5,
    },
    noDataIcon: {
        fontSize: 50,
        color: theme.palette.text.primary,
    },
}));
